module.exports = __webpack_public_path__ + "img/4.08e7e7cc.png";